import React from "react";
import { Dropdown } from "semantic-ui-react";
import classNames from "classnames";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { connectField } from "uniforms";

import currencies from "iso-currencies";
import { IFieldProps } from "./_interfaces";

const SHORT_LIST = ["EUR", "USD", "GBP", "CNY"];

const GET_CURRENCY = gql`
  query getCurrencies($accountId: String) {
    getCurrencies(accountId: $accountId) {
      currencies
    }
  }
`;

const currencyList = Object.entries(currencies.list()).map(([key, { symbol }]) => ({
  key,
  value: key,
  text: key,
  content: (
    <>
      {key}
      <span style={{ opacity: 0.3 }}>
        (
        {symbol}
        )
      </span>
    </>
  )
}));
export const currencyOptions = [
  ...currencyList.filter(({ key }) => SHORT_LIST.includes(key)),
  { key: "divider", content: <div className="ui divider" /> },
  ...currencyList.filter(({ key }) => !SHORT_LIST.includes(key))
];

export const CurrencyDropdown = ({
  asLabel,
  disabled,
  id,
  inputRef,
  onChange,
  placeholder,
  required,
  accountId,
  multiple = false,
  value,
  additionalOptions = []
}: ICurrencySelectProps) => {
  const dropdownOptions = asLabel
    ? { disabled, search: true, className: "label" }
    : {
      id,
      ref: inputRef,
      disabled,
      required,
      selection: true,
      fluid: false,
      search: true,
      multiple,
      placeholder
    };

  let option = [...additionalOptions.map((v) => ({ text: v, value: v })), ...currencyOptions];

  const {
    data = {},
    loading,
  } = useQuery(GET_CURRENCY, {
    variables: { accountId },
    skip: !accountId
  });
  if (!loading) {
    const currencies = currencyList.filter(({ key }) => (data?.getCurrencies?.currencies || []).includes(key));
    if (currencies.length) { option = [...additionalOptions.map((v) => ({ text: v, value: v })), ...currencies]; }
  }

  return (
    <Dropdown
      {...dropdownOptions}
      onChange={(_, { value: changedValue }) => {
        onChange(String(changedValue));
      }}
      value={value || option[0]?.value}
      options={option}
    />
  );
};


export type ICurrencySelectProps = IFieldProps<string, {asLabel?: boolean, accountId?: string, multiple?: boolean, additionalOptions?: string[]}>

const CurrencySelect = (props: ICurrencySelectProps) => {
  const { required, error, id, label, className } = props;
  return (
    <div className={classNames("field", className, { required, error })}>
      <label htmlFor={id}>{label}</label>
      <CurrencyDropdown {...props} />
    </div>
  );
};

export default connectField<ICurrencySelectProps>(CurrencySelect);
